'use strict';

/**
 * Inline SVG media-control icons from client/default/images/icons.
 * Consumed by swiper banner autoplay toggle / video thumbs.
 */
module.exports = {
  play: require('../../images/icons/Play-white.svg'),
  pause: require('../../images/icons/Pause.svg')
};
